import { compose } from 'redux';
import { connectModal } from 'redux-modal';
import DownloadModal from 'js/components/organisms/Modals/DownloadModal';
export default compose(connectModal({
  name: 'DownloadModal',
  destroyOnHide: false
}))(DownloadModal);